import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { StateService } from '@uirouter/angular';
import { MatDialog } from '@angular/material';
import { Subject, BehaviorSubject } from 'rxjs';
import { ToastrService, ActiveToast, IndividualToastrConfig } from 'ngx-toastr';
import { v1 as uuid } from 'uuid';
import * as JSZip from 'jszip';

import { AppinfoService } from './../../services/appinfo.service';
import { CommonRequestService } from './../../services/common-request.service';
import { SocketService, SocketMessageFE, SocketLogs } from './../../services/socket.service';
import { UserService } from './../../services/user.service';
import { AppSettings } from './../../app.settings';
import { LayerSelectModalComponent } from './layer-select-modal/layer-select-modal.component';
import { LayerPreviewModalComponent } from './jobs-field-mapping/layer-preview-modal/layer-preview-modal.component';

import { RE } from './../../../assets/TS/FileReverseEng';
import { FP } from './../../../assets/TS/FileProcess';
import { LayerMaintainType } from 'app/services/layer.service';
import { QcType } from 'app/services/layer-qc.service';
import { AdminService } from 'app/services/admin.service';

export interface Layer {
	name: string;
	type: string; // 'fgdb', 'fgdbZip', 'shp', 'shpZip'
	maintainType: LayerMaintainType;
	fileName: string; // Name of the file which the layer belongs to.
	content: any; // layer content
	category?: string; // layer category name // This is picked by user
	cateGeomType?: 'POINT' | 'AREA' | 'LINE';
}

@Injectable()
export class ContentJobsService {

	// Wizard on or off
	public wizard: 'on' | 'off' = 'off';

	// Layers for uploading
	public layers: BehaviorSubject<Layer[]> = new BehaviorSubject([]);
	// Uploading messages by processId
	public uploadingLogs: BehaviorSubject<SocketLogs> = new BehaviorSubject({});
	// On uploading finish
	public onUploadingFinish: Subject<{isError: boolean; customerId?: number;}> = new Subject();
	
	// public uploadWithQcProcesses: {
	// 	[uploadProcessId: string]: {
	// 		qcProcessId: string;
	// 	};
	// } = {};
	
	//
	private rawFiles: FP.GroupedFiles = {
		fgdb: {},
		fgdbZip: {},
		shp: {},
		shpZip: {}
	};
	constructor(
		public dialog: MatDialog,
		private router: Router,
		// private stateService: StateService,
		private toastr: ToastrService,
		private adminService: AdminService,
		private appinfoService: AppinfoService,
		private requestService: CommonRequestService,
		private socketService: SocketService,
		private userService: UserService
	) { }

	// Upload files
	async uploadFiles(qcType: QcType) {
		return new Promise<{processId}>((resolve, reject) => {
			let fileListJson;
			const formData = new FormData();
	
			fileListJson = this.getFilesJson();
	
			formData.append('sessionId', this.appinfoService.getSessionUuid());
			formData.append('userId', this.userService.getUserInfo().userId.toString());
			formData.append('userSubscriptionId', this.userService.getUserInfo().userSubId.toString());
			formData.append('spec', JSON.stringify(fileListJson));
			formData.append('qcType', qcType);
			for (const fileType of Object.keys(this.rawFiles)) {
				const files = this.rawFiles[fileType];
				for (const file of Object.keys(files)) {
					formData.append('uploads', files[file].zip);
				}
			}
	
			// const toast = this.generateUploadingToast('info', this.generateUploadingToastMessage('processing'));
	
			// Generate a temporary processId before the true processId is returned from the service call
			const tempProcessId = uuid();
			// Init a process for socketProcesses
			this.socketService.onInitProcess.next({
				tempId: tempProcessId,
				processType: 'Upload'
			});
			const url = AppSettings.serviceRootUrl + 'azgiv/file';
			console.log('fileListJson: ', fileListJson);
			return this.requestService.requestPost(url, formData,
				(rsp) => {
					const processesById = this.uploadingLogs.getValue();
					const processId = rsp.data.content;
					// Update processId for socketProcesses
					this.socketService.onInitProcess.next({
						tempId: tempProcessId,
						processId: processId,
						processType: 'Upload'
					});
	
					// Register the process for socketLogs
					this.socketService.registerProcessById(rsp.data.content, processesById);
					//
					this.uploadingLogs.next(processesById);
					// Clear uploaded data
					this.rawFiles = {
						fgdb: {},
						fgdbZip: {},
						shp: {},
						shpZip: {}
					};
					this.layers.next([]);
	
						// // Store if need qc
						// if (withQC) {
						// 	this.uploadWithQcProcesses[processId] = {
						// 		qcProcessId: null // will be updated when uploading is finished
						// 	};
						// }
					resolve({
						processId: processId
					})
				}, (err) => {
					// Trigger a fake socket message to stop socket
					this.socketService.filePostSubject.next({
						processId: tempProcessId,
						processType: 'Upload',
						isFinal: true,
						isError: true,
						isCanceled: false,
						dataType: 'json',
						data: { errorMessage: '', errorDetail: ''},
						timeStamp: new Date().toLocaleString('en-US')
					});
					reject(err);
				});
				// options);
		});
	}

	// Generate toast message
	generateUploadingToastMessage(type: 'processing' | 'final', msg?: string): string {
		msg = msg || '';
		switch (type) {
			case 'processing':
				return `<div>Uploading <div class="loading-dots"></div></div>
				<div>${msg}</div>`;
			case 'final':
				// Set Default msg
				msg = msg || `<div>Uploading completed.</div>`;
				return msg;
		}
	}
	// Generate toast
	generateUploadingToast(type: 'info' | 'success' |'error' | 'warning', message: string ): ActiveToast<any> {
		let toast: ActiveToast<any>;
		const config: Partial<IndividualToastrConfig> = Object.assign({}, this.socketService.toastrConfig);
		switch (type) {
			case 'info':
				toast = this.toastr.info(message, null, config);
				toast.onTap.subscribe(() => {
					// this.stateService.go('jobsuploadlogs');
					this.router.navigate(['azgiv/jobs/upload-logs']);
				});
				break;
			case 'success':
				config.tapToDismiss = true;
				toast = this.toastr.success(message, null, config);
				toast.onTap.subscribe(() => {
					// this.stateService.go('jobsfilesreview');
					this.router.navigate(['azgiv/review/data-view']);
				});
				break;
			case 'error':
				toast = this.toastr.error(message, null, this.socketService.toastrConfig);
				break;
			case 'warning':
				toast = this.toastr.warning(message, null, this.socketService.toastrConfig);
		}
		return toast;
	}

	// Read and process loaded files
	async transformLoadedFiles(files: File[] | FileList): Promise<FP.GroupedFiles> {
		const rsp = await FP.FileUtility.groupFiles(files);
		const rsp2 = await FP.FileUtility.processFilesByType(rsp);
		return rsp2;
	}

	// Read and process dropped files
	async transformDroppedFiles(items: DataTransferItem[] | DataTransferItemList): Promise<FP.GroupedFiles> {
		const rsp = await FP.FileUtility.getFilesFromDataTransferItems(items);
		if (rsp) {
			const rspGroupedFile = await FP.FileUtility.groupFilesMix(rsp);
			const rsp2 = await FP.FileUtility.processFilesByType(rspGroupedFile);
			return rsp2;
		}
	}

	addRawFiles(addedFiles: FP.GroupedFiles) {
		const merged = FP.GeneralUtility.mergeObjectsLevel1([this.rawFiles, addedFiles]);
		this.rawFiles = merged;
	}
	removeRawFilesByLayer(layer: Layer) {
		if (!layer) {
			console.log('Remove layer failed! layer: ' + layer);
			return;
		}
		const rawFile = this.rawFiles[layer.type][layer.fileName];
		switch (layer.type) {
			// Delete shp layer directly
			case 'shp':
				delete this.rawFiles[layer.type][layer.fileName];
				break;
			// The rest of types are processed in the same way
			default:
				delete this.rawFiles[layer.type][layer.fileName].layers[layer.name];
				if (!Object.keys(this.rawFiles[layer.type][layer.fileName].layers).length) {
					delete this.rawFiles[layer.type][layer.fileName];
				}
		}
	}


	// Group and Filter files in a fgdb for reading
	filterFgdbFiles(filesByName) {
		const fileGroup: any = {};
		const filesExclude = ['a00000001', 'a00000002', 'a00000003', 'a00000005', 'a00000006', 'a00000007', 'a00000008'];
		for (const name of Object.keys(filesByName)) {
			const file = filesByName[name];
			// File name without extension
			const nameNoExt = name.slice(0, name.lastIndexOf('.'));
			const nameSplits = name.split('.');
			let extension = nameSplits[nameSplits.length - 1];
			extension = extension ? extension.toUpperCase() : '';
			// Filter out files that are not layer
			if (filesExclude.indexOf(name.split('.')[0]) !== -1) {
				continue;
			}
			// Filter out file types that are not needed
			if (extension !== 'GDBTABLX' && extension !== 'GDBTABLE') {
				continue;
			}
			if (!fileGroup[nameNoExt]) {
				fileGroup[nameNoExt] = {};
			}
			fileGroup[nameNoExt][extension] = file;
		}
		return fileGroup;
	}
	// getFilesJson(name, layersInfo) {
	// 	const filesJson = {
	// 		layers: [{
	// 			name: name,
	// 			layers: []
	// 		}]
	// 	};
	// 	// layersInfo.forEach((i) => {

	// 	// });
	// 	return filesJson;
	// }
	getFilesJson() {
		const fileLayers = [];
		const layers = this.layers.getValue();
		// Update rawFiles layers info
		layers.forEach((l) => {
			const rawFile = this.rawFiles[l.type][l.fileName];
			switch (l.type) {
				case 'shp':
					rawFile.layerName = l.fileName;
					rawFile.category = l.category;
					rawFile.epsg = l.content.epsg || l.content.epsgInput;
					rawFile.featureType = FP.FileSpec.convertFeatureType(l.content.type);
					rawFile.maintainType = l.maintainType;
					break;
				default:
					const layer = rawFile.layers[l.name];
					layer.layerName = l.name;
					layer.category = l.category;
					layer.epsg = l.content.epsg || l.content.epsgInput;
					layer.featureType = FP.FileSpec.convertFeatureType(l.content.type);
					layer.maintainType = l.maintainType;
			}
		});
		for (const fileType of Object.keys(this.rawFiles)) {
			const files = this.rawFiles[fileType];
			switch (fileType) {
				case 'shp':
					for (const f of Object.keys(files)) {
						// const fileJson = this.getFeatureFileJson_SingleLayer(files[f], 'shapefile');
						const fileJson = this.getFeatureFileJson_MultiLayers([files[f]], f, 'shapefile');
						fileLayers.push(fileJson);
					}
					break;
				default:
					for (const f of Object.keys(files)) {
						const fileJson = this.getFeatureFileJson_MultiLayers(files[f].layers, f, fileType);
						fileLayers.push(fileJson);
					}
			}
		}
		return {
			state_cd: this.userService.getSelectedCustomerInfo('stateCode'),
			cus_id: this.userService.getCustomerIdByType(),
			files: fileLayers
		};
	}
	// Get fileJson of feature files including fgdb, fgdbZip, shpZip
	getFeatureFileJson_MultiLayers(layers, name, type): FP.FilesJsonSpatial {
		const filesJson: FP.FilesJsonSpatial = FP.FileSpec.initFilesJsonSpatial();
		filesJson.uniqueName = uuid();
		switch (type) {
			case 'shapefile':
				filesJson.type = 'shapefile';
				filesJson.name = name + '.shp';
				break;
			case 'shpZip':
				filesJson.type = 'shapefile';
				filesJson.name = name + '.zip';
				break;
			case 'fgdb':
				filesJson.type = 'fgdb';
				filesJson.name = name;
				break;
			case 'fgdbZip':
				filesJson.type = 'fgdb';
				filesJson.name = name + '.zip';
		}
		for (const layer of Object.keys(layers)) {
			const layerJson: FP.LayerJsonSpatial = this.getFeatureFileJson_SingleLayer(layers[layer], type, layers[layer].maintainType);
			filesJson.layers.push(layerJson);
		}
		return filesJson;
	}
	getFeatureFileJson_SingleLayer(file, type, maintainType: LayerMaintainType): FP.LayerJsonSpatial {
		const fileJson: FP.LayerJsonSpatial = FP.FileSpec.initLayerJson(false);
		fileJson.name = file.layerName;
		fileJson.sequence = null;
		fileJson.maint_type = maintainType;
		// fileJson.type = file.featureType;
		// This is not in use currently since proj4 and geom_col is obtained at backend
		fileJson.layer_spec = {
			// type: type,
			// srid: file.epsg || file.epsgInput,
			proj4: null,
			geom_col: null // 'geom'
		};
		const layerType = this.appinfoService.layerTypeList.find((t) => {
			return t.name === file.category;
		});
		fileJson.type = layerType.code;
		// const cols = (layerType && layerType.standardCols) ? layerType.standardCols : [];
		// fileJson.attr_cols = cols.reduce((filtered, col) => {
		// 	if (col.matchedCol) {
		// 		filtered.push({
		// 			standard_name: col.colName,
		// 			col_name: col.matchedCol.name,
		// 			data_type: col.colType
		// 		});
		// 	}
		// 	return filtered;
		// }, []);
		const fields = (type === 'shapefile' || type === 'shpZip') ? file.info.fields : file.fields;
		// The text field need additional info: field length
		// For fgdb, use maxLength to represent length
		const lenghProp = (type === 'shapefile' || type === 'shpZip') ? 'length' : 'maxLength';
		fileJson.attr_cols = fields.map((col) => {
			let standardName = null;
			let definedBy = null;
			if (col.matchedStandardCol && col.matchedStandardCol.colName) {
				standardName = col.matchedStandardCol.colName;
				// Specify whether the column is defined by nena or state
				switch (col.matchedStandardCol.definedBy) {
					case 'NENA': definedBy = 'nena'; break;
					case 'GIV': definedBy = 'GIV'; break;
					default: definedBy = 'state';
				}
				// definedBy = col.matchedStandardCol.definedBy === 'NENA' ? 'nena' : 'state';
			}
			const formattedCol = {
				standard_name: standardName,
				col_name: col.name,
				data_type: col.LBType,
				col_length: null,
				defined_by: definedBy
			};
			if (col.LBType === 'text') {
				formattedCol.col_length = col[lenghProp];
			}
			return formattedCol;
		});
		return fileJson;
	}

	openLayerSelectWindow(data?, successCallback?: Function) {
		const dialogRef = this.dialog.open(LayerSelectModalComponent, {
			width: '470px',
			height: '366px',
			data: data
		});
		return dialogRef.afterClosed().subscribe((rsp) => {
			if (successCallback) {
				successCallback(rsp);
			}
		});
	}
	openPreviewDialogWindow(data) {
		this.dialog.open(LayerPreviewModalComponent, {
			width: '1267px',
			height: '600px',
			data: data
		});
	}

}
